// Email Service using Cloudflare Worker API
// This service calls our Cloudflare Worker instead of EmailJS directly
// to hide API credentials from the client-side

export interface EmailParams {
  to_name: string;
  from_name: string;
  from_email: string;
  phone: string;
  company: string;
  product_category: string;
  message: string;
  country: string;
  submitted_date: string;
  submitted_time: string;
  reply_to: string;
}

// Get the API URL from environment or use local development URL
const getApiUrl = (): string => {
  // For production, use the same origin
  if (import.meta.env.PROD) {
    return '/api/send-email';
  }
  // For development, use local worker or production worker
  return import.meta.env.VITE_WORKER_API_URL || 'http://localhost:8787/api/send-email';
};

export const sendEnquiryEmail = async (params: EmailParams): Promise<boolean> => {
  const apiUrl = getApiUrl();

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        from_name: params.from_name,
        from_email: params.from_email,
        phone: params.phone,
        company: params.company,
        product_category: params.product_category,
        message: params.message,
        country: params.country,
        submitted_date: params.submitted_date,
        submitted_time: params.submitted_time,
        reply_to: params.from_email,
      }),
    });

    if (response.ok) {
      console.log('Email sent successfully via Worker API');
      return true;
    } else {
      const error = await response.json();
      console.error('Failed to send email:', error);
      return false;
    }
  } catch (error) {
    console.error('Failed to send email:', error);
    return false;
  }
};

// Fallback: Show form data in console for development
export const logEnquiryData = (params: EmailParams): void => {
  console.log('=== NEW ENQUIRY ===');
  console.log('Name:', params.from_name);
  console.log('Email:', params.from_email);
  console.log('Phone:', params.phone);
  console.log('Company:', params.company);
  console.log('Product Category:', params.product_category);
  console.log('Country:', params.country);
  console.log('Message:', params.message);
  console.log('Submitted:', params.submitted_date, 'at', params.submitted_time);
  console.log('===================');
};

